import { UserRole } from "../../common/service/server/Types";

export function formatUserRole(role: UserRole) {
  switch (role) {
    case "HR":
      return "HR";
    case "GENERAL":
      return "General";
    case "ADMIN":
      return "Admin";
  }
}
